// src/components/ui/SocialButton.tsx
import React from 'react';
import { Button } from './Button';

interface SocialButtonProps {
  provider: 'google' | 'github' | 'facebook';
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
}

export const SocialButton: React.FC<SocialButtonProps> = ({ 
  provider, 
  onClick, 
  loading, 
  disabled 
}) => {
  const config = {
    google: {
      icon: "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c1/Google_%22G%22_logo.svg/768px-Google_%22G%22_logo.svg.png",
      text: "Sign in with Google",
      bgColor: "bg-white dark:bg-[#2C2C2E]"
    },
    github: {
      icon: "https://github.githubassets.com/favicons/favicon.svg",
      text: "Sign in with GitHub",
      bgColor: "bg-gray-900 text-white dark:bg-gray-800"
    },
    facebook: {
      icon: "https://www.facebook.com/favicon.ico",
      text: "Sign in with Facebook",
      bgColor: "bg-[#1877F2] text-white"
    }
  };

  const { icon, text, bgColor } = config[provider];

  return (
    <Button
      type="button"
      variant="outline"
      fullWidth
      onClick={onClick}
      loading={loading}
      disabled={disabled}
      className={`${bgColor} hover:opacity-90`}
    >
      <img src={icon} className="w-5 h-5" alt={provider} />
      {text}
    </Button>
  );
};